import { ProductStatus } from '../../shared/models/product.model';
import { ISortModel } from '../../shared/models/sort.model';
import { IReplacingProduct } from './article.model';

export interface IBomModel extends ISortModel {
  quantity: number;
  article: Partial<IBOMItem>;
  delivery?: string;
}

export interface IBOMItem {
  id?: number;
  price: number;
  description: string;
  ref: string;
  eNumber: number;
  picture3D: string;
  deliverToCustomer: boolean;
  deliverToPanelBuilder: boolean;
  productId: number;
  productTypeId?: number;
  columnNumber?: number;
  rowNumber?: number;
  width?: number;
  isCustomDevice?: boolean;
  status: ProductStatus;
  enclosureId?: number;
  productCharacteristicsLink: string;
  productInfoLink: string;
  canTransferToWholesaler: boolean;
  isNxsDummy?: boolean;
  stockLevel?: number;
  replacingProduct?: IReplacingProduct;
  priceBeforeDiscount?: number;
}

export interface IShoppingCart {
  wholesalerUnableToTransferDevicesIncluded: boolean;
  preWiringDevicesIncluded: boolean;
  numberOfPositions: number;
}

export interface IShoppingCartData {
  hookUrl: string;
  postData: IBomShoppingCartPostData;
}

interface IBomShoppingCartPostData {
  result: string;
  version: string;
}

export enum BOMTables {
  'BOM',
  'ACCESSORIES',
  'PROJECT_COMPONENTS'
}

export enum DocumentsTables {
  'DOCUMENTS',
  'APARTMENTS',
  'PROTOCOLS'
}

export enum BomTableIdentifier {
  BOM = 'bom',
  ACCESSORIES = 'accessories',
  PROJECT_COMPONENTS = 'project_components'
}

export interface IEcommerceCart {
  value: number;
  items: IEcommerceBomItem[];
}

export interface IEcommerceBomItem {
  itemId: string;
  itemName: string;
  price: number;
  quantity: number;
  configurationId: number;
  projectId: number;
}
